import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconInfoOutline = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconInfoOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M12.106 18a1 1 0 0 0 .74-.306 1.04 1.04 0 0 0 .3-.76v-5.049a1 1 0 0 0-.308-.732 1.06 1.06 0 0 0-1.72.334 1 1 0 0 0-.078.398v5.048a1.02 1.02 0 0 0 .313.761 1.03 1.03 0 0 0 .753.306m-.11-9.519a1.08 1.08 0 0 0 1.02-.65q.083-.197.078-.412a1.1 1.1 0 0 0-.314-.819 1.06 1.06 0 0 0-.777-.31 1.08 1.08 0 0 0-.8.305 1.09 1.09 0 0 0-.3.8 1.04 1.04 0 0 0 .314.778 1.07 1.07 0 0 0 .778.308m0 15.52c-1.603.01-3.19-.315-4.66-.953A12.14 12.14 0 0 1 .953 16.66a11.92 11.92 0 0 1 0-9.34A12.3 12.3 0 0 1 3.54 3.5 12.1 12.1 0 0 1 7.35.934 11.7 11.7 0 0 1 11.994 0c1.607-.01 3.199.308 4.678.934 1.429.6 2.727 1.47 3.822 2.566a12.1 12.1 0 0 1 2.564 3.826c.63 1.48.948 3.073.938 4.68a11.6 11.6 0 0 1-.934 4.653 12 12 0 0 1-2.567 3.793 12.4 12.4 0 0 1-3.825 2.586A11.5 11.5 0 0 1 11.99 24zm.02-2.107a9.921 9.921 0 1 0-7-2.906 9.5 9.5 0 0 0 6.993 2.906z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconInfoOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
